import { useState } from 'react'
import { Theme } from '@monorepo/relayably/theme'

import { LoginPane } from './LoginPane'
import { OtpPane } from './OtpPane'
import { RecoveryPane } from './RecoveryPane'
import { SignUpPane } from './SignUpPane'
import { AuthLayout } from './components/AuthLayout'

export type FlowMode = 'LOGIN' | 'SIGNUP' | 'OTP' | 'RECOVERY' | 'FORGOT_PASSWORD'

export const AuthFlow = ({ theme }: { theme: Theme }) => {
  const [mode, setMode] = useState<FlowMode>('LOGIN')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [otpIntent, setOtpIntent] = useState<'sign-in' | 'sign-up'>('sign-in')
  const [fullName, setFullName] = useState('Alex Hart')

  const titleMap: Record<FlowMode, { title: string; subtitle: string }> = {
    LOGIN: {
      title: 'Welcome back',
      subtitle: 'Sign in to keep setting up Relayably.',
    },
    SIGNUP: {
      title: 'Create an account',
      subtitle: 'Get started in a few quick steps.',
    },
    OTP: {
      title: 'Enter your code',
      subtitle: `We've sent a code to ${phoneNumber || 'your phone number'}.`,
    },
    FORGOT_PASSWORD: {
      title: 'Reset password',
      subtitle: "We'll email you a reset link.",
    },
    RECOVERY: {
      title: 'Account recovery',
      subtitle: 'We’ll help you get back in.',
    },
  }

  return (
    <AuthLayout theme={theme} title={titleMap[mode].title} subtitle={titleMap[mode].subtitle}>
      {mode === 'LOGIN' ? (
        <LoginPane
          theme={theme}
          onForgotPassword={() => setMode('FORGOT_PASSWORD')}
          onOtpRequest={phone => {
            setPhoneNumber(phone)
            setOtpIntent('sign-in')
            setMode('OTP')
          }}
          onSwitchToSignUp={() => setMode('SIGNUP')}
        />
      ) : null}
      {mode === 'SIGNUP' ? (
        <SignUpPane
          theme={theme}
          onOtpRequest={(phone, name) => {
            setPhoneNumber(phone)
            setFullName(name)
            setOtpIntent('sign-up')
            setMode('OTP')
          }}
          onSwitchToLogin={() => setMode('LOGIN')}
        />
      ) : null}
      {mode === 'OTP' ? (
        <OtpPane
          fullName={fullName}
          intent={otpIntent}
          onBack={() => setMode(otpIntent === 'sign-up' ? 'SIGNUP' : 'LOGIN')}
          phoneNumber={phoneNumber}
          theme={theme}
        />
      ) : null}
      {mode === 'FORGOT_PASSWORD' || mode === 'RECOVERY' ? (
        <RecoveryPane
          mode={mode}
          onBack={() => setMode('LOGIN')}
          onStartRecovery={() => setMode('RECOVERY')}
          theme={theme}
        />
      ) : null}
    </AuthLayout>
  )
}
